/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_contract'
export default icon
